import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LivePreviewComponent } from './live-preview/live-preview.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PipeUtilModule } from '../../../../app/modules/pipes/pipe-util/pipe-util.module';
import { MiniLivePreviewComponent } from './mini-live-preview/mini-live-preview.component';

@NgModule({
  declarations: [LivePreviewComponent, MiniLivePreviewComponent],
  imports: [
    CommonModule,
    PipeUtilModule,
    NgbModule
  ],
  exports: [LivePreviewComponent,MiniLivePreviewComponent]
})
export class LivePreviewModule { }
